import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 16
  },
  tableFilter: {
    marginTop: 16,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  }
}))
